module.exports = __webpack_public_path__ + "assets/img/header_title.48fda7f6.png";